// Normaliza el `catalog` de un Servicio de aplicación a la lista de valores candidatos.
// La CMDB solo persiste hoy un único valor por servicio (`catalog: string`), pero se
// acepta también `string[]` de forma defensiva: si el modelo de datos evoluciona a
// admitir varios catalogs por servicio, esta función ya lo soporta sin más cambios.
export function getCatalogCandidates(catalog?: string | string[]): string[] {
  const values = Array.isArray(catalog) ? catalog : catalog ? [catalog] : [];
  return [...new Set(values.filter(Boolean))];
}
